<template>
  <div class="row newsletter no-gutters w-100 gtm-onElementVisiblity" :class="colorTheme"
       gtm-on="elementVisibility"
       :gtm-visibility-category="gtmNewsletterCategory"
       gtm-visibility-action="Newsletter widget impression"
       :gtm-visibility-label="newsletterType.name"
       v-if="showNewsletter"
       >
    <div class="col-12">
      <div class="innerbox nested-border-1" :class="theme">
        <div class="innerbox nested-border-2" :class="theme">
          <transition name="newsletter-form-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <div class="innerbox nested-border-3" :class="theme" v-if="submit">
              <transition :duration="1000" name="newsletter-form-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
                <div class="innerbox nested-border-4" :class="theme">
                  <transition :duration="1000" name="newsletter-form-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
                    <div class="innerbox nested-border-5" :class="theme">
                      <div></div>
                    </div>
                  </transition>
                </div>
              </transition>
            </div>
          </transition>

          <transition :duration="1000" name="newsletter-form-transition" @after-enter="afterEnter" @after-leave="afterLeave" enter-active-class="animated-newsletter-form newsletter-zoomIn" leave-active-class="animated-newsletter-form newsletter-zoomOut" appear>
            <div class="newsletter-form p-3" v-if="!submit">
              <form @submit.prevent="onSubmit" novalidate class="mx-auto" >
                <div class="row no-gutters justify-content-between">
                  <div class="col-11">
                    <div class="title">GET OUR</div>
                    <div class="title"><span class="text-uppercase">{{newsletterType.name}}</span> NEWSLETTER</div>
                  </div>
                  <div class="col-1">
                    <div class="mail-icon float-right">
                      <svg-email-large-icon :fill="color" width="100%" height="100%"></svg-email-large-icon>
                    </div>
                  </div>
                </div>
                <input type="email" :class="{'warning-color': warning }" class="form-control border-right-0 border-left-0 border-top-0 pl-0 InputEmail" id="InputEmail1" v-model.trim="email" placeholder="your email">
                <div class="warning">
                  <p class="pr-1 pl-1 m-0 h-100" v-if="warning">Email Address is not valid.</p>
                </div>
                <button type="submit" class="btn submit-newsletter btn-sm">SIGN UP</button>
              </form>
            </div>
          </transition>

          <div class="subscition-box" v-if="subscition">
            <div class="subscition">
              <div class="row align-items-center w-100 h-100 no-gutters">
                <div class="col-12 d-flex align-items-center inner-subscrition">
                  <div class="mx-auto">
                    <transition name="newsletter-form-transition" enter-active-class="animated fadeInUp" leave-active-class="animated fadeInUP" appear>
                      <div class="mail-icon mx-auto animated rotateIn">
                        <svg-email-large-icon :fill="color" width="100%" height="100%"></svg-email-large-icon>
                      </div>
                    </transition>

                    <div class="subscrite">
                      <transition name="newsletter-form-transition" @enter="thankyouEnter" @after-leave="thankyouLeave" enter-active-class="animated fadeInUp" leave-active-class="animated fadeInUP" appear>
                        <div class="text-center subscrition-text">
                          THANK YOU
                        </div>
                      </transition>
                      <transition name="newsletter-form-transition" enter-active-class="animated-last fadeInUp" leave-active-class="animated-last fadeInUP" appear>
                        <div class="text-center subscrition-text" v-if="lastText">
                          YOU ARE NOW ON THE LIST.
                        </div>
                      </transition>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import get from 'lodash/get'

import SvgEmailLargeIcon from 'static/svg/icon_email1.svg'
import SvgEmailIcon from 'static/svg/icon_email.svg'
import NewsletterMixin from 'components/mixins/newsletter'
import GTMManager from 'mixins/gtm-manager'

export default {
  mixins: [NewsletterMixin],
  props: {
    newsletterType: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      default: 'white', // white, black
    },
  },
  data() {
    return {
      color: '#F8008E',
      submit: false,
      email: '',
      warning: false,
      subscition: false,
      lastText: false,
    }
  },
  components: {
    SvgEmailLargeIcon,
    SvgEmailIcon,
  },
  computed: {
    ...mapState(['showNewsletter']),
    colorTheme() {
      let colorTheme = ''
      switch (this.newsletterType.color) {
        case 'blue': {
          colorTheme = 'innerbox-blue'
          break
        }
        case 'yellow': {
          colorTheme = 'innerbox-yellow'
          break
        }
        case 'green': {
          colorTheme = 'innerbox-green'
          break
        }
        default: {
          colorTheme = 'innerbox-blue'
        }
      }
      return `${colorTheme} ${this.theme}`
    },
    gtmNewsletterCategory() {
      const gtmType = 'gtmType_newsletter-inline'
      return get(GTMManager.getDynamicGtmEventsByType(gtmType, {}), 'category', false)
    },
  },
  methods: {
    afterLeave() {
      this.subscition = true
      this.play2()
    },
    afterEnter() {
      this.subscition = false
    },
    thankyouEnter() {
      this.lastText = true
    },
    thankyouLeave() {
      this.lastText = true
    },
    onSubmit(e) {
      if (this.validateEmail(this.email)) {
        this.play1()
        this.warning = false
        this.submit = true
        e.target.style.display = 'none'
        this.subscribeNewsletter(this.email, this.newsletterType, this.gtmNewsletterCategory)
      } else {
        this.warning = true
        this.submit = false
        this.subscition = false
        e.target.style.display = 'block'
      }
    },
  },
  mounted() {
    this.checkSubscribedToList(this.newsletterType)
  },
}
</script>
 <style lang="scss" scoped>
.newsletter {

  &.white{
    .newsletter-form {
      background: $white;
      .title {
        color: $manatee;
        span {
          color: $black;
        }
      }
    }
    .InputEmail{
      background-color: $white;
    }
  }
  &.black{
    .newsletter-form {
      background: $black;
      .title {
        color: $manatee;
        span {
          color: $white;
        }
      }
      .InputEmail{
        background-color: $black;
        color: $white;
      }
    }
  }

  .nested-border-1, .nested-border-2, .nested-border-3, .nested-border-4, .nested-border-5 {
    &.white{
      border-color: $white !important;
    }
    &.black{
      border-color: $black !important;
    }
  }

  font-family: $barlow;
  .warning {
      margin-top: rem-calc(-3);
      margin-bottom: rem-calc(3);

    p {
      background: $neon-fuchsia;
      font-size: rem-calc(12);
      line-height: rem-calc(20);
      color: $white;
      font-weight: bold;
    }
    height: rem-calc(20);
  }
  .mail-icon {
    width: rem-calc(24);
    height: rem-calc(18);
  }
  .newsletter-form {
    position: absolute;
    top: rem-calc(7);
    left: 0;
    right: 0;
    margin: 0 auto;
    margin-right: rem-calc(7);
    margin-left: rem-calc(7);
    height: rem-calc(175);

    .InputEmail {
      font-family: $barlow;
      font-size: rem-calc(24);
      border-radius: unset;
      border-bottom: 3px solid $manatee;

      &.warning-color {
        color: $neon-fuchsia;
      }
      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &::-moz-placeholder {
        /* Firefox 19+ */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &:-ms-input-placeholder {
        /* IE 10+ */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &:-moz-placeholder {
        /* Firefox 18- */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
    }
    input {
      caret-color: $rose;
      outline-width: 2px;
    }
    .submit-newsletter {
      height: rem-calc(41);
      width: rem-calc(160);
      font-family: $barlow;
      background: $rose;
      border-radius: unset;
      color: $white;
      font-size: rem-calc(18);
      padding-left: rem-calc(42);
      padding-right: rem-calc(42);
      &:hover {
        background: $neon-fuchsia;
        box-shadow: none;

        @include respond-to('mobile') {
          background: $jazzberry-jam;
        }
      }
      &:focus {
        background: $jazzberry-jam;
        box-shadow: none;
      }
    }
    .title {
      font-size: rem-calc(14);
      line-height: rem-calc(16);
      font-weight: bold;
    }
  }
  &.innerbox-blue {
    background: $waterspout;
  }
  &.innerbox-yellow {
    background: $banana-yellow;
  }
  &.innerbox-green {
    background: $medium-aquamarine;
  }

  height: rem-calc(237);
  .innerbox {
    height: rem-calc(219);
    border: rem-calc(3) solid;
    margin: rem-calc(10);
    .innerbox {
      height: rem-calc(195);
      position: relative;
      border: rem-calc(3) solid;
      .innerbox {
        border: rem-calc(2) solid;
        height: rem-calc(167);
        .innerbox {
          border: rem-calc(1) solid;
          height: rem-calc(141);
          .innerbox {
            border: rem-calc(1) solid;
            height: rem-calc(117);
            position: relative;
            div {
              height: rem-calc(117);
            }
          }
        }
      }
    }
  }
  .subscition-box {
    height: rem-calc(189);
    position: absolute;
    top: rem-calc(4);
    left: 0;
    right: 0;
    margin: 0 auto;
    height: rem-calc(115);
    width: rem-calc(241);
    top: 15%;
    .subscition {
      padding: rem-calc(10);
      .inner-subscrition {
        height: rem-calc(111);
        .mail-icon {
          margin-bottom: rem-calc(11.86)
        }
        .subscrition-text {
          font-size: rem-calc(14);
          line-height: rem-calc(16);
          font-weight: bold;
        }
      }
    }
  } // transition effect
  @keyframes newsletter-zoomIn {
    from {
      opacity: 1;
      transform: scale3d(.3, .3, .3);
    }

    50% {
      opacity: 1;
    }
  }

  .newsletter-zoomIn {
    animation-name: newsletter-zoomIn;
  }

  @keyframes newsletter-zoomOut {
    from {
      opacity: 1;
    }

    to {
      transform: scale3d(0, 0, 0);
      opacity: 1;
    }
  }

  .newsletter-zoomOut {
    animation-name: newsletter-zoomOut;
  }

  .animated-last {
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  .animated-newsletter-form {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }
}
</style>



// WEBPACK FOOTER //
// InlineNewsletterForm.vue?3a084c1a